import React from "react";
import { reportError, type ReportedError } from "@/lib/errorReporting";
import { ErrorCodeDisplay } from "./ErrorCodeDisplay";
import { Button } from "@/components/ui/button";

type State = {
  reported: ReportedError | null;
};

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { reported: null };

  static getDerivedStateFromError() {
    return {};
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    reportError(error, {
      source: "frontend",
      extra: { componentStack: info.componentStack, type: "react_error_boundary" },
    }).then((r) => this.setState({ reported: r }));
  }

  render() {
    if (this.state.reported) {
      const r = this.state.reported;
      return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-background">
          <div className="max-w-lg w-full space-y-4">
            <h1 className="text-2xl font-semibold">Une erreur inattendue s'est produite</h1>
            <p className="text-muted-foreground">{r.userMessage}</p>
            <ErrorCodeDisplay code={r.code} hint={r.hint} />
            <div className="flex gap-2">
              <Button onClick={() => window.location.reload()}>Recharger la page</Button>
              <Button variant="outline" onClick={() => (window.location.href = "/")}>Retour à l'accueil</Button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
